import msalApi from "../config/setupMSALAxios"; // your configured Axios instance

export async function getUserData() {
  // No need to set headers if your interceptor handles it
  const response = await msalApi.get('/api/Account/GetUserData');
  return response.data;
}


